import React, { useEffect, useRef, useState } from "react";
import clsx from "clsx";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";
import "swiper/css/navigation";
import SEO from "../../components/SEO";
import { Collapse, makeStyles } from "@material-ui/core";
import { useInView } from "react-intersection-observer";
import { color, motion, transform } from "framer-motion";
import Link from "../../components/v2/Link";
import LazyImage from "../../components/v4/LazyLoadImage/LazyImage";
import FaqSection from "../../components/v4/FaqSection/FaqSection";
import TruestedSection from "../../components/v4/TrustedSection/TruestedSection";
import TestimonialSlider from "../../components/v3/TestimonialSlider/TestimonialSlider";

import heroSectionBg from "../../images/v4/whatsappBroadcast/images/heroSectionBg.png";
import accordianTabsBg from "../../images/v4/whatsappAiChatbot/images/accordianTabsBg.png";
import benefitsBg from "../../images/v4/whatsappAiChatbot/images/benefitsBg.png";
import realWorldBg from "../../images/v4/whatsappBroadcast/images/realWorldBg.png";

import cardImg1 from "../../images/v4/whatsappBroadcast/images/cardImg1.webp";
import cardImg2 from "../../images/v4/whatsappBroadcast/images/cardImg2.webp";

import bannerIcon1 from "../../images/v4/whatsappBroadcast/icons/bannerIcon1.svg";
import bannerIcon2 from "../../images/v4/whatsappBroadcast/icons/bannerIcon2.svg";
import bannerIcon3 from "../../images/v4/whatsappBroadcast/icons/bannerIcon3.svg";
import bannerIcon4 from "../../images/v4/whatsappBroadcast/icons/bannerIcon4.svg";

import adaptImg1 from "../../images/v4/salesManagers/clientSlider/img1.png";
import adaptImg2 from "../../images/v4/salesManagers/clientSlider/img2.png";
import adaptImg3 from "../../images/v4/salesManagers/clientSlider/img3.png";
import adaptImg4 from "../../images/v4/salesManagers/clientSlider/img4.png";
import adaptImg5 from "../../images/v4/salesManagers/clientSlider/img5.png";
import adaptImg6 from "../../images/v4/salesManagers/clientSlider/img6.png";
import adaptImg7 from "../../images/v4/salesManagers/clientSlider/img7.png";

import experienceImg1 from "../../images/v4/whatsappBroadcast/images/experienceImg1.webp";
import experienceImg2 from "../../images/v4/whatsappBroadcast/images/experienceImg2.webp";
import experienceImg3 from "../../images/v4/whatsappBroadcast/images/experienceImg3.webp";
import experienceImg4 from "../../images/v4/whatsappBroadcast/images/experienceImg4.webp";
import experienceImg5 from "../../images/v4/whatsappBroadcast/images/experienceImg5.webp";
import experienceImg6 from "../../images/v4/whatsappBroadcast/images/experienceImg6.webp";

import realWorldImage1 from "../../images/v4/whatsappBroadcast/images/realWorldImage1.webp";
import realWorldImage2 from "../../images/v4/whatsappBroadcast/images/realWorldImage2.webp";
import realWorldImage3 from "../../images/v4/whatsappBroadcast/images/realWorldImage3.webp";
import realWorldImage4 from "../../images/v4/whatsappBroadcast/images/realWorldImage4.webp";
import realWorldImage5 from "../../images/v4/whatsappBroadcast/images/realWorldImage5.webp";

import compareItemImg1 from "../../images/v4/whatsappBroadcast/images/compareItemImg1.webp";
import compareItemImg2 from "../../images/v4/whatsappBroadcast/images/compareItemImg2.webp";
import compareItemImg3 from "../../images/v4/whatsappBroadcast/images/compareItemImg3.webp";
import compareItemImg4 from "../../images/v4/whatsappBroadcast/images/compareItemImg4.webp";
import compareItemImg5 from "../../images/v4/whatsappBroadcast/images/compareItemImg5.webp";

import salesImg1 from "../../images/v4/whatsappBroadcast/icons/salesImg1.svg";
import salesImg2 from "../../images/v4/whatsappBroadcast/icons/salesImg2.svg";
import salesImg3 from "../../images/v4/whatsappBroadcast/icons/salesImg3.svg";
import salesImg4 from "../../images/v4/whatsappBroadcast/icons/salesImg4.svg";
import salesImg5 from "../../images/v4/whatsappBroadcast/icons/salesImg5.svg";
import salesImg6 from "../../images/v4/whatsappBroadcast/icons/salesImg6.svg";
import salesImg7 from "../../images/v4/whatsappBroadcast/icons/salesImg7.svg";

import bannerTick from "../../images/v4/salesReps/heroTick.svg";
import arrowRight from "../../images/v4/salesReps/arrowRight.svg";
import downArrow from "../../images/v4/aiPage/icons/downArrow.svg";

const useStyles = makeStyles((theme) => ({
  SalesMangerSection: {
    backgroundSize: "cover",
    backgroundImage: `url(${heroSectionBg})`,
    padding: "60px 0 0",
    backgroundPosition: "top",
    overflow: "hidden",
    "@media only screen and (max-width: 1024px)": {
      maxHeight: "100%",
      minHeight: "100%",
      "& .container": {
        height: "auto",
      },
      "& .centerContainer": {
        width: "90%",
        marginTop: "50px",
      },
    },

    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
      width: "80%",
      margin: "0 auto",
      textAlign: "center",
      marginTop: "70px",
    },

    "@media only screen and (max-width: 768px)": {
      padding: "0",
      "& .centerContainer": {
        width: "95%",
        marginTop: "40px",
        gap: "24px",
      },
    },
    "@media only screen and (max-width: 600px)": {
      "& .centerContainer": {
        width: "100%",
        marginTop: "30px",
        gap: "20px",
      },
    },
    "@media only screen and (max-width: 480px)": {
      "& .centerContainer": {
        marginTop: "20px",
        gap: "16px",
      },
    },
  },
  SalesMangerContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    height: "100%",
  },
  heroContent: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    gap: "32px",
    textAlign: "center",
    margin: "0 auto 64px",
    maxWidth: "1200px",
    "& p": {
      maxWidth: "1000px",
      marginBottom: "8px",
    },
    "@media(max-width:1024px)": {
      "& h1": {
        margin: "0",
      },
    },
  },
  bannerCards: {
    display: "flex",
    alignItems: "flex-start",
    gap: "24px",
    flexWrap: "nowrap", // default unless overridden below
    "& .bannerCard:nth-of-type(1), & .bannerCard:nth-of-type(4)": {
      transform: "translateY(25px) !important",
    },
    "@media (max-width:1024px)": {
      flexWrap: "wrap",
      alignItems: "stretch",
      "& .bannerCard:nth-of-type(1), & .bannerCard:nth-of-type(4)": {
        transform: "translateY(0) !important",
      },
    },
    "@media(max-width:768px)": {
      gap: "15px",
    },
  },
  cardContainer: {
    borderRadius: "20px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "18px",
    padding: "25px",
    background: "rgba(0, 44, 81, 0.4)",
    backdropFilter: "blur(20px)",
    height: "320px",
    position: "relative",
    overflow: "hidden",
    "&.greenCard": {
      background: "#4F1F75",
      "&.glass-effect": {
        "&::before": {
          content: '""',
          position: "absolute",
          width: "250px",
          height: "250px",
          zIndex: "-1",
          background: "#9E5AD5",
          borderRadius: "50%",
          filter: "blur(80px)",
          opacity: "var(--before-opacity, 0)",
          left: "var(--before-left, 0)",
          top: "var(--before-top, 0)",
          transition: "opacity 0.3s ease",
          pointerEvents: "none",
        },
      },
    },
    "&.purpleCard": {
      background: "#09939A",
      "&.glass-effect": {
        "&::before": {
          content: '""',
          position: "absolute",
          width: "400px",
          height: "400px",
          zIndex: "-1",
          background: "#9E5AD5",
          borderRadius: "50%",
          filter: "blur(200px)",
          opacity: "var(--before-opacity, 0)",
          left: "var(--before-left, 0)",
          top: "var(--before-top, 0)",
          transition: "opacity 0.3s ease",
          pointerEvents: "none",
        },
      },
    },
    "&.blueCard": {
      background: "#174C79",
      "&.glass-effect": {
        "&::before": {
          content: '""',
          position: "absolute",
          width: "250px",
          height: "250px",
          zIndex: "-1",
          background: "#208EEC",
          borderRadius: "50%",
          filter: "blur(80px)",
          opacity: "var(--before-opacity, 0)",
          left: "var(--before-left, 0)",
          top: "var(--before-top, 0)",
          transition: "opacity 0.3s ease",
          pointerEvents: "none",
        },
      },
    },
    "&.regularCard": {
      background: "#4F1F75",
      "&.glass-effect": {
        "&::before": {
          content: '""',
          position: "absolute",
          width: "250px",
          height: "250px",
          zIndex: "-1",
          background: "#FF8B3D",
          borderRadius: "50%",
          filter: "blur(100px)",
          opacity: "var(--before-opacity, 0)",
          left: "var(--before-left, 0)",
          top: "var(--before-top, 0)",
          transition: "opacity 0.3s ease",
          pointerEvents: "none",
        },
      },
    },
    "@media(max-width:1024px)": {
      "&.bannerCard": {
        width: "48%",
        minWidth: "48%",
        height: "auto",
      },
    },
    "@media(max-width:992px)": {
      "&.bannerCard": {
        width: "48%",
        minWidth: "48%",
        height: "auto",
        "& h3": {
          margin: "0",
        },
      },
    },
    "@media(max-width:600px)": {
      padding: "16px",
      gap: "8px",
      "&.bannerCard": {
        width: "48%",
        minWidth: "46%",
        height: "auto",
        "& h3": {
          margin: "0",
        },
      },
    },
    "@media(max-width:400px)": {
      padding: "16px",
      gap: "8px",
      "&.bannerCard": {
        width: "47%",
        minWidth: "46%",
        height: "auto",
        "& h3": {
          margin: "0",
        },
      },
    },
  },
  Client: {
    position: "relative",
    zIndex: "10",
    "& .container": {
      paddingTop: "0",
      "@media(max-width:1024px)": {
        padding: "65px 25px",
        "& .client-logo": {
          "& img": {
            width: "auto",
            height: "30px",
          },
        },
      },
      "@media(max-width:768px)": {
        "& .client-logo": {
          "& img": {
            width: "auto",
            height: "25px",
          },
        },
      },

      "@media(max-width:600px)": {
        padding: "40px 15px",
        "& .client-logo": {
          "& img": {
            width: "auto",
            height: "20px",
          },
        },
      },
    },
    "& p": {
      textAlign: "center",
      marginBottom: "32px",
    },
    "& .client-logo": {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      "& img": {
        width: "auto",
        height: "30px",
      },
    },
  },
  integrationSection: {},
  integrationHeader: {
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    gap: "70px",
    "@media only screen and (max-width: 1024px)": {
      gap: "30px",
    },
    "@media only screen and (max-width: 768px)": {
      flexDirection: "column",
      gap: "40px",
      alignItems: "center",
      textAlign: "center",
    },
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      gap: "30px",
      alignItems: "flex-start",
      textAlign: "left",
    },
    "& $integrationLeft": {
      flexDirection: "column",
      gap: "32px",
      alignItems: "flex-start",
      alignItems: "flex-start",
      textAlign: "left",
      display: "flex",
      width: "45%",
      "@media only screen and (max-width: 768px)": {
        width: "100%",
      },
      "@media only screen and (max-width: 600px)": {
        width: "100%",
      },
    },
    "& $integrationRight": {
      width: "50%",
      "@media only screen and (max-width: 768px)": {
        width: "100%",
      },
      "@media only screen and (max-width: 600px)": {
        width: "100%",
      },
    },
    "& .buttonContaienr": {
      marginTop: "42px",
      "@media only screen and (max-width: 1024px)": {
        marginTop: "35px",
      },
      "@media only screen and (max-width: 768px)": {
        marginTop: "30px",
      },
      "@media only screen and (max-width: 600px)": {
        marginTop: "20px",
      },
      "@media only screen and (max-width: 480px)": {
        marginTop: "15px",
      },
      "& a": {
        color: "#FF682A",

        "&:hover": {
          color: "#fff",
        },
      },
    },
  },
  integrationRightImage: {
    width: "100%",
  },
  experienceContainer: {
    position: "relative",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    "& .centerContainer": {
      width: "70%",
      margin: "0 auto",
      textAlign: "center",
      "@media only screen and (max-width: 1024px)": {
        width: "80%",
      },
      "@media only screen and (max-width: 768px)": {
        width: "90%",
      },
      "@media only screen and (max-width: 600px)": {
        width: "100%",
      },
    },
  },
  experienceInnerContainer: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    width: "100%",
    marginTop: "20px",
    gap: "40px",
    "@media only screen and (max-width: 1024px)": {
      gap: "30px",
    },
    "@media only screen and (max-width: 768px)": {
      flexDirection: "column",
      gap: "40px",
      alignItems: "center",
      marginTop: "0",
    },
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      gap: "20px",
      alignItems: "flex-start",
    },
    "@media only screen and (max-width: 480px)": {
      gap: "15px",
    },
  },
  experienceContainerLeft: {
    width: "40%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "16px",
    "& .exp-desc": {
      marginBottom: "24px",
    },
    "& .view-more-link": {
      textDecoration: "underline",
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      color: "#1D6FB6",
      gap: "10px",
      "@media only screen and (max-width: 768px)": {
        marginBottom: "15px",
      },
      "& img": {
        display: "inline-block!important",
        width: "16px!important",
        height: "16px",
        marginTop: "3px!important",
        transition: "transform 0.5s ease",
      },
      "&:hover": {
        color: "#010F1D",
        "& img": {
          transform: "translateX(5px)",
        },
      },
    },
    "@media only screen and (max-width: 1024px)": {
      width: "50%",
      gap: "20px",
    },
    "@media only screen and (max-width: 768px)": {
      width: "100%",
      gap: "24px",
      alignItems: "center",
      textAlign: "center",
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      marginTop: "0",
      alignItems: "flex-start",
      textAlign: "left",
    },
    "@media only screen and (max-width: 480px)": {
      gap: "18px",
    },
  },
  experienceContainerRight: {
    width: "60%",
    minHeight: "450px",
    "& img": {
      width: "100%",
      height: "100%",
    },
    "@media only screen and (max-width: 768px)": {
      display: "none",
    },
  },
  faqHeading: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    "@media only screen and (max-width: 1024px)": {
      gap: "15px",
    },
    "@media only screen and (max-width: 768px)": {
      gap: "12px",
    },
    "@media only screen and (max-width: 600px)": {
      "& h3": {
        textAlign: "left",
      },
      gap: "10px",
    },
    "@media only screen and (max-width: 480px)": {
      gap: "8px",
    },
  },
  downArrow: {
    transition: "0.3s ease",
    "&.active": {
      transform: "rotate(180deg)",
    },
  },
  body: {
    textAlign: "left",
    "& img": {
      display: "none",
    },
    "@media only screen and (max-width: 1024px)": {
      margin: "8px 0 0",
    },
    "@media only screen and (max-width: 768px)": {
      margin: "6px 0 0",
      "& img": {
        display: "block",
        width: "100%",
        marginTop: "12px",
      },
    },
    "@media only screen and (max-width: 600px)": {
      "& img": {
        display: "block",
        width: "100%",
        marginTop: "15px",
      },
    },
    "@media only screen and (max-width: 480px)": {
      margin: "5px 0 0",
      "& img": {
        marginTop: "10px",
      },
    },
    "& .exp-desc": {
      margin: "10px 0",
    },
  },

  accordianTabs: {
    backgroundSize: "cover",
    backgroundImage: `url(${accordianTabsBg})`,
    padding: "60px 0 0",
    backgroundPosition: "top",
    paddingTop: "240px",
    position: "relative",
    "@media only screen and (max-width: 1024px)": {
      paddingTop: "250px",
    },
    "@media only screen and (max-width: 768px)": {
      paddingTop: "330px",
    },

    "& .headercenterContainer": {
      display: "flex",
      alignItems: "flex-start",
      justifyContent: "space-between",
      marginBottom: "64px",
      gap: "100px",
      "& h2": {
        width: "80%",
      },
      "& p": {
        width: "40%",
      },
      "@media (max-width:768px)": {
        flexDirection: "column",
        gap: "18px",
        marginBottom: "55px",
        "& h2": {
          width: "100%",
        },
        "& p": {
          width: "100%",
        },
      },
    },
  },
  faqsContainer: {
    marginTop: "60px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    cursor: "pointer",
    width: "100%",
    "@media only screen and (max-width: 768px)": {
      marginTop: "20px",
    },
    "@media only screen and (max-width: 600px)": {
      marginTop: "15px",
    },
  },
  faqBox: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    borderBottom: "1px solid #B7B7B7",
    width: "100%",
    padding: "15px 0",
    "&:first-child": {
      borderTop: "1px solid #B7B7B7",
    },
    "@media only screen and (max-width: 768px)": {
      marginBottom: "15px",
    },
    "@media only screen and (max-width: 600px)": {
      marginBottom: "12px",
    },
  },
  integrationLeft: {
    "@media only screen and (max-width: 768px)": {
      textAlign: "center",
    },
    "@media only screen and (max-width: 600px)": {
      textAlign: "left",
    },
  },
  integrationRight: {
    "@media only screen and (max-width: 768px)": {
      maxWidth: "500px",
      margin: "0 auto",
    },
    "@media only screen and (max-width: 600px)": {
      maxWidth: "400px",
    },
    "@media only screen and (max-width: 480px)": {
      maxWidth: "350px",
    },
  },
  faqBoxAccordian: {
    padding: "24px",
    backgroundColor: "#f8fcff",
    borderRadius: "16px",
    cursor: "pointer",
    "&.active": {
      backgroundImage: " linear-gradient(89deg, #e0effd 4%, #e0fafa 100%)",
    },
    "@media(max-width:768px)": {
      padding: "16px",
    },
  },
  experienceHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    cursor: "pointer",
    "&.noClick": {
      cursor: "not-allowed",
    },
    "& h3": {
      margin: "0",
    },
  },
  realWorldTabs: {
    backgroundImage: `url(${realWorldBg})`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    paddingTop: "300px",
    "& .container": {
      padding: "0 0 120px",
    },
    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
      width: "100%",
      margin: "0 auto",
      textAlign: "center",
      "& h2": {
        width: "80%",
      },
    },
    "@media only screen and (max-width: 1200px)": {
      "& .centerContainer": {
        width: "100%",
        "& h2": {
          width: "100%",
        },
      },
    },
    "@media only screen and (max-width: 1024px)": {
      paddingTop: "250px",
      "& .container": {
        padding: "0 24px 65px",
      },
    },
    "@media only screen and (max-width: 768px)": {
      padding: "250px 15px 65px",
      "& .container": {
        padding: "0 15px",
      },
    },
    "@media only screen and (max-width: 600px)": {
      padding: "180px 15px 40px",
      "& .container": {
        padding: "0",
      },
      "& .centerContainer": {
        "& h2": {
          width: "100% !important",
        },
      },
    },
  },
  tabsContainer: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "8px",
    border: "2px solid #DBDBDB",
    borderRadius: "40px",
    background: "#fff",
    overflow: "auto",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      padding: "5px",
    },
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
  tab: {
    width: "33%",
    background: "",
    padding: "18px",
    background: "transparent",
    borderRadius: "40px",
    background: "transparent",
    transition: "0.3s ease",
    cursor: "pointer",
    minWidth: "max-content",
    "&.active": {
      color: "white",
      background:
        "linear-gradient(90deg, #FF682A 0%, #FF7056 35%, #FF682A 73%, #FF550F 100%)",
    },
    "@media only screen and (max-width: 600px)": {
      minWidth: "max-content",
      padding: "10px",
    },
  },
  tabCard: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    marginTop: "32px",
    gap: "40px",
    "@media only screen and (max-width: 768px)": {
      flexDirection: "column",
      gap: "40px",
    },
  },
  tabCardLeftContainer: {
    display: "flex",
    width: "50%",
    gap: "40px",
    flexDirection: "column",
    alignItems: "flex-start",
    "@media only screen and (max-width: 768px)": {
      alignItems: "center",
      width: "100%",
    },
  },
  tabCardRightContainer: {
    width: "45%",
    "@media only screen and (max-width: 768px)": {
      width: "100%",
      maxWidth: "500px",
      margin: "0 auto",
    },
  },
  benfitListContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "30px",
    marginTop: "50px",
    "@media only screen and (max-width: 600px)": {
      gap: "15px",
      marginTop: "20px",
    },
  },
  benfitListItem: {
    display: "flex",
    width: "100%",
    margin: "0 auto",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "15px",
    position: "relative",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      gap: "15px",
      alignItems: "flex-start",
    },
  },
  benfitListItemContent: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    gap: "10px",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  benfitIcon: {
    width: "24px !important",
    "& img": {
      width: "100%",
    },
    "@media only screen and (max-width: 600px)": {
      width: "24px !important",
    },
  },
  absoulteCard: {
    position: "absolute",
    margin: "0 auto",
    width: "100%",
    top: "100%",
    transform: "translate(-50% ,-50%)",
    left: "50%",
    right: "0",
    zIndex: "1",
    "& .container": {
      paddingTop: "0",
    },
    "@media only screen and (max-width: 768px)": {},
  },
  commonPageFooterSection: {
    background:
      "transparent linear-gradient(90deg, #011D32 0%, #00182B 100%) 0% 0% no-repeat padding-box",
    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
      width: "80%",
      margin: "0 auto",
      textAlign: "center",
    },
    "@media only screen and (max-width: 1024px)": {
      "& .centerContainer": {
        width: "90%",
        gap: "28px",
      },
    },
    "@media only screen and (max-width: 768px)": {
      "& .centerContainer": {
        width: "95%",
        gap: "24px",
      },
    },
    "@media only screen and (max-width: 600px)": {
      "& .centerContainer": {
        width: "100%",
        gap: "20px",
      },
    },
    "@media only screen and (max-width: 480px)": {
      "& .centerContainer": {
        gap: "16px",
      },
    },
  },
  wpFaq: {
    "& section": {
      padding: "0px 0 40px !important",
    },

    "@media only screen and (max-width: 1024px)": {
      "& section": {
        padding: "0px 0 35px !important",
      },
    },
    "@media only screen and (max-width: 768px)": {
      "& section": {
        padding: "0px 0 30px !important",
      },
    },
    "@media only screen and (max-width: 600px)": {
      "& section": {
        padding: "0px 0 40px !important",
      },
    },
    "@media only screen and (max-width: 480px)": {
      "& section": {
        padding: "0px 0 25px !important",
      },
    },
  },
  compareSection: {
    position: "relative",
    paddingTop: "200px",
    paddingBottom: "80px",
    "& $supportBox": {
      position: "absolute",
      top: "-410px",
      background: "linear-gradient(0deg, #7C35B5 0%, #672A99 100%)",
    },
    "& .header": {
      width: "70%",
      margin: "0 auto",
      textAlign: "center",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
    },
    "@media only screen and (max-width: 600px)": {
      paddingTop: "540px",
      "& $supportBox": {
        top: "-770px",
      },
      "& .header": {
        width: "100%",
      },
    },
  },
  compareSection: {
    position: "relative",
    paddingTop: "200px",
    paddingBottom: "80px",
    "& .header": {
      width: "70%",
      margin: "0 auto",
      textAlign: "center",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
    },
    "@media only screen and (max-width: 1024px)": {
      paddingTop: "180px",
      paddingBottom: "70px",
      "& .header": {
        width: "80%",
        gap: "28px",
      },
    },
    "@media only screen and (max-width: 768px)": {
      paddingTop: "150px",
      paddingBottom: "60px",
      "& .header": {
        width: "90%",
        gap: "24px",
      },
    },
    "@media only screen and (max-width: 600px)": {
      paddingTop: "600px",
      paddingBottom: "40px",
      "& .container:first-child": {
        padding: "0px 15px",
      },
      "& .header": {
        width: "100%",
        gap: "20px",
      },
    },
    "@media only screen and (max-width: 480px)": {
      paddingTop: "500px",
      paddingBottom: "30px",
      "& .header": {
        gap: "16px",
      },
    },
  },
  compareSectionLeftItem: {
    padding: "15px 20px",
    borderLeft: "5px solid transparent",
    transition: "0.3s ease",
    "&.active": {
      borderLeft: "5px solid #02AE7F",
    },
    "& a": {
      textDecoration: "none",
      color: "#000",
    },
    "@media only screen and (max-width: 1024px)": {
      padding: "12px 16px",
    },
    "@media only screen and (max-width: 768px)": {
      padding: "10px 14px",
    },
    "@media only screen and (max-width: 600px)": {
      padding: "8px 12px",
    },
    "@media only screen and (max-width: 480px)": {
      padding: "6px 10px",
    },
  },
  compareSectionContainer: {
    gap: "40px",
    display: "flex",
    marginTop: "60px",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    position: "relative",
    "@media only screen and (max-width: 1024px)": {
      gap: "30px",
      marginTop: "50px",
    },
    "@media only screen and (max-width: 768px)": {
      flexDirection: "column",
      marginTop: "30px",
      gap: "20px",
    },
    "@media only screen and (max-width: 480px)": {
      gap: "15px",
      marginTop: "20px",
    },
  },
  compareSectionContainerLeftSection: {
    width: "30%",
    position: "sticky",
    top: "100px",
    "@media only screen and (max-width: 1024px)": {
      width: "35%",
      top: "80px",
    },
    "@media only screen and (max-width: 768px)": {
      width: "100%",
      position: "static",
      display: "none",
    },
  },
  compareSectionContainerRightSection: {
    width: "70%",
    "@media only screen and (max-width: 1024px)": {
      width: "65%",
    },
    "@media only screen and (max-width: 768px)": {
      width: "100%",
    },
  },
  compareItemContainer: {
    marginBottom: "60px",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    flexDirection: "column",
    gap: "20px",
    "& .productImage": {
      width: "100%",
    },
    "&:last-child": {
      marginBottom: 0,
    },
    "@media only screen and (max-width: 1024px)": {
      marginBottom: "50px",
      gap: "18px",
    },
    "@media only screen and (max-width: 768px)": {
      marginBottom: "40px",
      gap: "16px",
    },
    "@media only screen and (max-width: 600px)": {
      marginBottom: "30px",
      gap: "15px",
    },
    "@media only screen and (max-width: 480px)": {
      marginBottom: "25px",
      gap: "12px",
    },
  },
  topFiveHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
  },
  benifitSection: {
    position: "relative",
    paddingBottom: "300px",
    "& $absoulteCard": {
      position: "absolute",
      margin: "0 auto",
      width: "100%",
      top: "100%",
      transform: "translate(-50% ,-50%)",
      left: "50%",
      right: "0",
      "& $integrationHeader": {
        background: "linear-gradient(90deg, #015352 0%, #00926A 100%)",
        borderRadius: "32px",
        padding: "40px",
      },
      "& $integrationRight": {
        width: "40%",
      },
      "& .container": {
        paddingTop: "0",
      },
      "@media only screen and (max-width: 768px)": {
        "& $integrationHeader": {
          padding: "20px",
          borderRadius: "16px",
        },
        "& $integrationRight": {
          width: "100%",
        },
      },
    },
    "@media only screen and (max-width: 600px)": {
      paddingBottom: "350px",
    },
  },
  salesCrmCarousel: {
    position: "relative",
    backgroundImage: `url(${benefitsBg})`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    paddingBottom: "380px",
    "& .header-section": {
      flexDirection: "column",
      width: "55%",
      "& h2": {
        marginBottom: "32px",
      },
      "& p": {
        marginBottom: "0",
      },
      "@media(max-width:768px)": {
        width: "100%",
        "& h2": {
          marginBottom: "0",
        },
      },
    },
    "@media only screen and (max-width: 1024px)": {
      paddingBottom: "380px",
      "& .header": {
        width: "60%",
      },
    },
    "@media only screen and (max-width: 768px)": {
      paddingBottom: "350px",
      "& .header": {
        width: "80%",
      },
      "& h2": {
        marginBottom: "0",
      },
    },
    "@media only screen and (max-width: 600px)": {
      paddingBottom: "210px",
      "& .header": {
        width: "100%",
      },
      "& h2": {
        marginBottom: "0",
      },
    },
    "@media only screen and (max-width: 480px)": {
      paddingBottom: "220px",
      "& h2": {
        marginBottom: "0",
      },
    },
  },
  adaptSlider: {
    padding: "20px 0!important",
    "@media only screen and (max-width: 1024px)": {
      padding: "15px 4rem 50px",
    },
    "@media only screen and (max-width: 768px)": {
      padding: "15px 2rem 40px",
    },
    "@media only screen and (max-width: 600px)": {
      padding: "15px 15px 40px",
    },
    "@media only screen and (max-width: 480px)": {
      padding: "15px 10px 30px",
    },
    "@media only screen and (min-width: 1400px)": {
      padding: "15px 8rem 60px",
    },
    "@media only screen and (min-width: 1900px)": {
      padding: "15px 23rem 60px",
    },
    "& .swiper-wrapper": {
      alignItems: "stretch",
    },
  },
  adaptsBox: {
    gap: "24px",
    display: "flex!important",
    padding: "24px",
    background: "#fff",
    alignItems: "stretch",
    borderRadius: "20px",
    flexDirection: "column",
    justifyContent: "flex-start",
    boxShadow: "0px 0px 24px #D4E0E9",
    borderRadius: "16px",
    height: "auto!important",
    "@media only screen and (max-width: 1024px)": {
      padding: "20px",
      maxWidth: "350px",
      gap: "14px",
    },
    "@media only screen and (max-width: 768px)": {
      padding: "18px",
      maxWidth: "320px",
      gap: "12px",
    },
    "@media only screen and (max-width: 600px)": {
      padding: "15px",
      maxWidth: "80%",
      gap: "15px",
    },
    "@media only screen and (max-width: 480px)": {
      padding: "12px",
      maxWidth: "85%",
      gap: "10px",
    },
  },
  adaptDescription: {
    gap: "10px",
    minHeight: "80px",
    "@media only screen and (max-width: 1024px)": {
      minHeight: "70px",
    },
    "@media only screen and (max-width: 768px)": {
      minHeight: "60px",
    },
    "@media only screen and (max-width: 600px)": {
      alignItems: "baseline",
      minHeight: "auto",
    },
    "@media only screen and (max-width: 480px)": {
      minHeight: "auto",
    },
  },
  adaptBoxImg: {
    width: "48px",
    maxWidth: "48px",
    position: "relative",
    bottom: "0",
    marginBottom: "24px",
    "@media only screen and (max-width: 1024px)": {
      width: "44px",
      maxWidth: "44px",
      marginBottom: "20px",
    },
    "@media only screen and (max-width: 768px)": {
      width: "40px",
      maxWidth: "40px",
      marginBottom: "18px",
    },
    "@media only screen and (max-width: 600px)": {
      width: "36px",
      maxWidth: "36px",
      marginBottom: "16px",
    },
    "@media only screen and (max-width: 480px)": {
      width: "32px",
      maxWidth: "32px",
      marginBottom: "14px",
    },
  },
  testimonials: {
    background: "#F8FCFF",
    paddingBottom: "50px",
    "@media(max-width:1025px)": {
      paddingBottom: "24px",
    },
  },
}));

const WhatsappBroadcast = () => {
  const classes = useStyles();
  const sectionRef = useRef(null);
  const [activeRealWorld, setActiveRealWorld] = useState(0);
  const [activeAccordian, setActiveAccordian] = useState(0);
  const [activeCompare, setActiveCompare] = useState("#section0");

  useEffect(() => {
    // Select all cards that should have the effect
    const cardsToAnimate = [
      document.querySelector(`.${classes.cardContainer}:first-child`),
      document.querySelector(`.${classes.cardContainer}.blueCard`),
      ...document.querySelectorAll(`.${classes.cardContainer}.regularCard`),
      ...document.querySelectorAll(`.${classes.cardContainer}.purpleCard`),
      ...document.querySelectorAll(`.${classes.cardContainer}.greenCard`), // Add regularCards
    ];

    cardsToAnimate.forEach((card) => {
      if (!card) return;

      card.classList.add("glass-effect");

      // Set initial top-right position for the glass effect
      const setInitialPosition = () => {
        const rect = card.getBoundingClientRect();
        const topRightX = rect.width - 150; // Adjust this value to position from right edge
        const topRightY = 0; // Top position

        card.style.setProperty("--before-left", `${topRightX}px`);
        card.style.setProperty("--before-top", `${topRightY}px`);
        card.style.setProperty("--before-opacity", "0.8");
      };

      // Call it initially
      setInitialPosition();

      let lastX = null;
      let lastY = null;

      const handleMouseMove = (e) => {
        const rect = card.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;

        lastX = x;
        lastY = y;

        card.style.setProperty("--before-left", `${x - 75}px`);
        card.style.setProperty("--before-top", `${y - 75}px`);
      };

      const handleMouseEnter = () => {
        if (lastX !== null && lastY !== null) {
          card.style.setProperty("--before-left", `${lastX - 75}px`);
          card.style.setProperty("--before-top", `${lastY - 75}px`);
        }
        card.style.setProperty("--before-opacity", "0.8");
      };

      const handleMouseLeave = () => {
        card.style.setProperty("--before-opacity", "0.8");
      };

      // Store handlers on the card element for cleanup
      card.handlers = {
        mousemove: handleMouseMove,
        mouseenter: handleMouseEnter,
        mouseleave: handleMouseLeave,
        resize: setInitialPosition,
      };

      // Add event listeners
      card.addEventListener("mousemove", handleMouseMove);
      card.addEventListener("mouseenter", handleMouseEnter);
      card.addEventListener("mouseleave", handleMouseLeave);
      window.addEventListener("resize", setInitialPosition);
    });

    // Cleanup
    return () => {
      cardsToAnimate.forEach((card) => {
        if (!card) return;

        const handlers = card.handlers;
        if (handlers) {
          card.removeEventListener("mousemove", handlers.mousemove);
          card.removeEventListener("mouseenter", handlers.mouseenter);
          card.removeEventListener("mouseleave", handlers.mouseleave);
          window.removeEventListener("resize", handlers.resize);
        }
      });
    };
  }, [classes]);
  const clientList = [
    {
      img: adaptImg1,
    },
    {
      img: adaptImg2,
    },
    {
      img: adaptImg3,
    },
    {
      img: adaptImg4,
    },
    {
      img: adaptImg5,
    },
    {
      img: adaptImg6,
    },
    {
      img: adaptImg7,
    },
  ];

  const benifitList = [
    {
      img: cardImg1,
      title: "Effortlessly broadcast message on WhatsApp!",
      points: [
        {
          heading: "Schedule broadcast",
          content:
            "Set up your WhatsApp messages in advance to reach your audience at the perfect time, effortlessly boosting engagement.",
        },
        {
          heading: "Broadcast history",
          content:
            "Offers you a holistic view of your potential customers and provides you with a conversation history.",
        },
        {
          heading: "Broadcast report",
          content:
            "Get detailed insights tracking not just deliveries and failures, but also recipient responses. Measure engagement and refine your outreach with precision.",
        },
      ],
    },
  ];
  const faqs = [
    {
      question:
        "How is bulk WhatsApp broadcasting different from group messaging?",
      answer: (
        <>
          Unlike group messaging, bulk broadcasting maintains recipient privacy
          as they can't see each other. It also allows for more personalised and
          targeted communication. Check out{" "}
          <a href="https://blog.peppercloud.com/whatsapp-broadcast-vs-whatsapp-group/">
            WhatsApp Broadcast vs Group
          </a>{" "}
          to learn the difference in detail.
        </>
      ),
    },
    {
      question: "Can recipients see each other in a bulk WhatsApp broadcast?",
      answer: (
        <>
          No, recipients of a bulk WhatsApp broadcast cannot see other
          recipients, maintaining privacy.
        </>
      ),
    },
    {
      question: "How can I personalise my bulk WhatsApp broadcasts?",
      answer: (
        <>
          With the help of various types of Variables, you can add customer data
          to include personalised elements like names, recent purchases, or
          custom recommendations in your broadcasts.
        </>
      ),
    },
    {
      question:
        "How can I measure the success of my WhatsApp broadcast campaigns?",
      answer: (
        <>
          Most broadcast software, including Pepper Cloud CRM, provides
          analytics on metrics like delivery rates, open rates, click-through
          rates, and conversions.
        </>
      ),
    },
    {
      question: "Can recipients reply to bulk WhatsApp broadcasts?",
      answer: (
        <>
          Yes, recipients can reply to broadcasts using Pepper Cloud’s
          <a href="https://blog.peppercloud.com/whatsapp-message-templates-guidelines/">
            interactive WhatsApp message templates
          </a>
          . Good broadcast software will help you manage these replies
          efficiently.
        </>
      ),
    },
    {
      question:
        "How can I ensure my broadcasts comply with data protection regulations?",
      answer: (
        <>
          Use a reputable broadcast software like Pepper Cloud CRM that adheres
          to data protection standards, and always obtain explicit consent from
          your contacts.
        </>
      ),
    },
    {
      question: "Can I schedule WhatsApp broadcasts in advance?",
      answer: (
        <>
          Yes, most bulk WhatsApp broadcast software, including Pepper Cloud
          CRM, allows you to schedule broadcasts for future dates and times.
        </>
      ),
    },
    {
      question: "How can I grow my WhatsApp broadcast list?",
      answer: (
        <>
          Promote your WhatsApp channel across other marketing channels, offer
          exclusive content or deals, and make it easy for customers to opt-in.
        </>
      ),
    },
    {
      question: "Can I include links in my WhatsApp broadcasts?",
      answer: (
        <>
          Yes, you can include clickable links in your broadcasts, which can be
          tracked for engagement through your broadcast software.
        </>
      ),
    },
    {
      question:
        "What are the best practices for sending bulk WhatsApp broadcasts?",
      answer: (
        <>
          Here are some key best practices to follow:
          <ul>
            <li>
              Segment your audience using tags to send relevant and targeted
              messages.
            </li>
            <li>
              Personalise your messages with names and custom fields to boost
              engagement.
            </li>
            <li>
              Respect timing and frequency to avoid overwhelming recipients.
            </li>
            <li>
              Provide value in every message—share useful content, offers, or
              updates.
            </li>
            <li>Include clear CTAs to guide users on what to do next.</li>
            <li>Monitor and analyse performance to improve your strategy.</li>
            <li>
              Maintain list hygiene by removing inactive or outdated numbers.
            </li>
            <li>Comply with regulations and WhatsApp's policies.</li>
            <li>
              Test before sending to ensure the message appears as intended.
            </li>
            <li>
              Enable easy opt-outs to build trust and respect user preferences.
            </li>
          </ul>
        </>
      ),
    },
    {
      question:
        "How can I send WhatsApp broadcasts using WhatsApp Web integration with Pepper Cloud CRM?",
      answer: (
        <>
          To send WhatsApp broadcasts via WhatsApp Web integration in Pepper
          Cloud CRM:
          <ol>
            <li>Log in to Pepper Cloud CRM.</li>
            <li>Go to the ‘Leads’ or ‘Contacts’ module.</li>
            <li>Select the contacts you want to broadcast to.</li>
            <li>Click the ‘Action’ drop-down and choose ‘Send Broadcast’.</li>
            <li>
              Fill in the Broadcast Name, select the WhatsApp Web channel, and
              choose a message template.
            </li>
            <li>Add any tags and input recipient information.</li>
            <li>Click ‘Send’ to initiate the broadcast.</li>
            <li>Monitor the broadcast status in the ‘Bulk Action’ screen.</li>
          </ol>
          This process enables efficient bulk messaging directly through your
          CRM using WhatsApp Web.
        </>
      ),
    },
  ];
  const AUTO_PLAY_INTERVAL = 10000;

  const experienceList = [
    {
      title: "Advanced segmentation capabilities",
      alt: "WhatsApp broadcast feature for businesses.",
      img: experienceImg1,
      desc: "Use CRM tags to segment and target your audience based on demographics, behaviour, and preferences. Deliver highly effective WhatsApp broadcast campaigns to the right people, every time.",
    },
    {
      title: "Seamless CRM integration",
      alt: "Using WhatsApp Web for broadcasts.",
      img: experienceImg2,
      desc: "Leverage your existing customer data for more personalised and contextual WhatsApp messaging. Manage, segment, and communicate—all within one unified platform.",
    },
    {
      title: "Automated campaign scheduling",
      alt: "How WhatsApp broadcast lists work.",
      img: experienceImg3,
      desc: "Easily plan, schedule, and execute automated WhatsApp marketing campaigns. Ensure timely, relevant communication at every step of the customer journey.",
    },
    {
      title: "Rich media support",
      alt: "Broadcast message settings in WhatsApp.",
      img: experienceImg4,
      desc: "Enhance your WhatsApp broadcast messages with images, videos, and documents. Create more engaging, memorable, and impactful campaigns for your audience.",
    },
    {
      title: "Comprehensive analytics dashboard",
      alt: "Broadcast integration with WhatsApp Web.",
      img: experienceImg5,
      desc: "Monitor delivery rates, open rates, and conversions in real-time. Optimise your WhatsApp broadcast strategies with a detailed analytics dashboard.",
    },
    {
      title: "Compliance and security focused",
      alt: "WhatsApp sending one message privately.",
      img: experienceImg6,
      desc: "Ensure all broadcasts adhere to WhatsApp’s policies and data protection regulations. Maintain trust and confidence with your customers at every touchpoint.",
    },
  ];
  const { ref, inView } = useInView({
    threshold: 0.5, // adjust as needed
    triggerOnce: false,
  });
  useEffect(() => {
    let interval;

    const startAutoplay = () => {
      clearInterval(interval);
      interval = setInterval(() => {
        setActiveAccordian((prev) => (prev + 1) % experienceList.length);
      }, AUTO_PLAY_INTERVAL);
    };

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          startAutoplay();
        } else {
          clearInterval(interval);
        }
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      clearInterval(interval);
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, [experienceList.length]);

  // When user clicks on an accordion
  const handleAccordionClick = (index) => {
    setActiveAccordian(index);
    setUserSelected(true);

    // Restart autoplay so the full interval is shown after click
    // Without resetting to the next immediately
    clearInterval(intervalId);
    intervalId = setInterval(() => {
      setActiveAccordian((prev) => (prev + 1) % experienceList.length);
    }, AUTO_PLAY_INTERVAL);
  };

  useEffect(() => {
    // Select all cards that should have the effect
    const cardsToAnimate = [
      document.querySelector(
        `.${classes.statsContainer} .${classes.customerExperencesBox}:first-child`
      ),
      document.querySelector(
        `.${classes.statsContainer} .${classes.customerExperencesBox}.blueCard`
      ),
      document.querySelector(
        `.${classes.statsContainer} .${classes.customerExperencesBox}.regularCard`
      ),
    ];

    const setupCard = (card) => {
      if (!card) return;

      card.classList.add("glass-effect");

      const setInitialPosition = () => {
        const rect = card.getBoundingClientRect();
        const topRightX = rect.width - 150;
        const topRightY = 0;

        card.style.setProperty("--before-left", `${topRightX}px`);
        card.style.setProperty("--before-top", `${topRightY}px`);
        card.style.setProperty("--before-opacity", "0.8");
      };

      setInitialPosition();

      let lastX = null;
      let lastY = null;

      const handleMouseMove = (e) => {
        const rect = card.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;

        lastX = x;
        lastY = y;

        card.style.setProperty("--before-left", `${x - 75}px`);
        card.style.setProperty("--before-top", `${y - 75}px`);
      };

      const handleMouseEnter = () => {
        if (lastX !== null && lastY !== null) {
          card.style.setProperty("--before-left", `${lastX - 75}px`);
          card.style.setProperty("--before-top", `${lastY - 75}px`);
        }
        card.style.setProperty("--before-opacity", "0.8");
      };

      const handleMouseLeave = () => {
        card.style.setProperty("--before-opacity", "0.8");
      };

      const handlers = {
        mousemove: handleMouseMove,
        mouseenter: handleMouseEnter,
        mouseleave: handleMouseLeave,
        resize: setInitialPosition,
      };

      card.handlers = handlers;

      card.addEventListener("mousemove", handlers.mousemove);
      card.addEventListener("mouseenter", handlers.mouseenter);
      card.addEventListener("mouseleave", handlers.mouseleave);
      window.addEventListener("resize", handlers.resize);
    };

    cardsToAnimate.forEach(setupCard);

    return () => {
      cardsToAnimate.forEach((card) => {
        if (!card?.handlers) return;

        const { handlers } = card;
        card.removeEventListener("mousemove", handlers.mousemove);
        card.removeEventListener("mouseenter", handlers.mouseenter);
        card.removeEventListener("mouseleave", handlers.mouseleave);
        window.removeEventListener("resize", handlers.resize);
      });
    };
  }, [classes]);
  //card height
  useEffect(() => {
    const updateCardHeights = () => {
      const cards = document.querySelectorAll(".bannerCard");

      cards.forEach((card) => {
        if (window.innerWidth <= 1024) {
          card.style.height = "auto"; // let it size naturally
        } else {
          const originalHeight = card.offsetHeight;
          card.style.height = `${originalHeight}px`; // add 100px
        }
      });
    };

    // Run on mount
    updateCardHeights();

    // Run on resize
    window.addEventListener("resize", updateCardHeights);
    return () => window.removeEventListener("resize", updateCardHeights);
  }, []);
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 100; // Height of navigation bar
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
  };
  const tabContentData = [
    {
      tabContent: [
        {
          heading: "Personalised product recommendations",
          content:
            "Send abandoned cart reminders with enticing offers and suggest products that match each customer's unique preferences to boost sales.",
          alt: "Personalised product recommendations and abandoned cart reminders",
        },
        {
          heading: "Order tracking and delivery updates",
          content:
            "Notify customers about new product launches, exclusive deals, and keep them updated on their order status and deliveries in real-time.",
          alt: "Order tracking, delivery, and promotional notifications",
        },
        {
          heading: "Exclusive deals and new launches",
          content:
            "Share special promotions, product launches, and limited-time offers directly on WhatsApp to drive customer engagement and loyalty.",
          alt: "Exclusive deals and new product launches notifications",
        },
      ],
      image: realWorldImage1,
      alt: "Sending broadcast messages using WhatsApp.",
      subtitle:
        "Boost sales and customer loyalty with targeted promotions and real-time updates.",
    },
    {
      tabContent: [
        {
          heading: "Account alerts and transaction notifications",
          content:
            "Send instant account balance alerts and transaction notifications to keep your customers updated on their finances.",
          alt: "Account alerts and real-time transaction updates",
        },
        {
          heading: "Personalised product offers",
          content:
            "Promote tailored credit cards, loans, or investment plans based on each customer's profile and preferences.",
          alt: "Customised financial product offers",
        },
        {
          heading: "EMI and bill payment reminders",
          content:
            "Provide timely reminders for EMI dues, bill payments, and policy renewals to help customers stay organised and avoid late fees.",
          alt: "EMI and bill payment reminders",
        },
        {
          heading: "Renewal and policy alerts",
          content:
            "Notify customers in advance about upcoming insurance renewals and policy expirations, ensuring continuous coverage.",
          alt: "Policy renewal notifications",
        },
      ],
      image: realWorldImage2,
      alt: "Creating a WhatsApp broadcast list.​",
      subtitle:
        "Enhance customer service and promote financial products effectively.",
    },
    {
      tabContent: [
        {
          heading: "Appointment scheduling and confirmations",
          content:
            "Send appointment reminders, booking confirmations, and ensure smooth scheduling for patients and healthcare providers.",
          alt: "Medical appointment scheduling and confirmations",
        },
        {
          heading: "Medication reminders",
          content:
            "Distribute medication adherence notifications and timely health tips to help patients stay on track with their regimens.",
          alt: "Medication reminders and health notifications",
        },
        {
          heading: "Lab reports and follow-up instructions",
          content:
            "Deliver diagnostic results securely and guide patients with post-consultation or follow-up care information.",
          alt: "Lab results and post-consultation care via WhatsApp",
        },
        {
          heading: "Health tips and wellness content",
          content:
            "Share relevant health tips, wellness content, and lifestyle advice directly with patients for ongoing engagement.",
          alt: "Wellness and health tips on WhatsApp",
        },
      ],
      image: realWorldImage3,
      alt: "WhatsApp broadcast software sending messages.",
      subtitle:
        "Improve patient care and streamline healthcare communications.",
    },
    {
      tabContent: [
        {
          heading: "Class schedules and academic reminders",
          content:
            "Keep students informed about timetable changes, academic calendar events, holidays, and important dates.",
          alt: "Academic schedule and reminders sent via WhatsApp",
        },
        {
          heading: "Assignment and test alerts",
          content:
            "Notify students about assignment deadlines, upcoming exams, and submission reminders for better academic performance.",
          alt: "Assignment and exam notifications",
        },
        {
          heading: "Learning materials and resource sharing",
          content:
            "Send PDFs, videos, links, and notes directly to student devices for convenient and interactive learning.",
          alt: "Learning resources sharing on WhatsApp",
        },
        {
          heading: "Parent communication and event updates",
          content:
            "Update parents on school events, student performance, attendance, and achievements to foster better engagement.",
          alt: "Parent and school communication on WhatsApp",
        },
      ],
      image: realWorldImage4,
      alt: "Creating a WhatsApp broadcast list.​",
      subtitle:
        "Enhance student engagement and streamline administrative communications.",
    },
    {
      tabContent: [
        {
          heading: "Booking confirmations and check-in details",
          content:
            "Instantly confirm bookings and share check-in or boarding passes, ensuring a seamless travel experience.",
          alt: "Booking confirmation and check-in notifications",
        },
        {
          heading: "Real-time itinerary changes",
          content:
            "Alert travellers about flight delays, schedule changes, or last-minute updates for hassle-free journeys.",
          alt: "Itinerary updates via WhatsApp",
        },
        {
          heading: "Local tips and personalised suggestions",
          content:
            "Recommend restaurants, local attractions, and hidden gems based on guest preferences for a personalised stay.",
          alt: "Local tips and suggestions for travelers",
        },
        {
          heading: "Post-stay feedback and loyalty offers",
          content:
            "Gather guest reviews after their stay and share rebooking incentives or loyalty rewards to boost retention.",
          alt: "Feedback and loyalty offers post-stay",
        },
      ],
      image: realWorldImage5,
      alt: "WhatsApp broadcast software sending messages.",
      subtitle:
        "Elevate guest experiences and drive bookings with timely personalised communications.",
    },
  ];
  const compareItems = [
    "Pepper Cloud CRM",
    "Gallabox",
    "Wati.io",
    "Interkt",
    "AiSensy",
  ];
  const compareData = [
    {
      title: "Pepper Cloud CRM",
      desc: "Pepper Cloud CRM stands out as the top choice for bulk WhatsApp broadcasting in 2024. This comprehensive platform seamlessly integrates WhatsApp API capabilities with robust CRM functionality, allowing businesses to efficiently manage and engage their contacts at scale. Pepper Cloud CRM offers a user-friendly interface for creating, scheduling, and sending personalised broadcast campaigns while providing detailed analytics to measure their effectiveness.",
      img: compareItemImg1,
      alt: "Best WhatsApp broadcast CRM for businesses",
      features: [
        {
          title: "WhatsApp template message management",
          desc: "Easily create and manage WhatsApp message templates for compliant and effective broadcasting.",
        },
        {
          title: "Segmentation and targeting",
          desc: "Advanced filtering to send highly relevant broadcast messages to specific audience segments.",
        },
        {
          title: "Broadcast scheduling",
          desc: "Plan and automate message delivery for optimal reach and engagement.",
        },
        {
          title: "Message dashboard",
          desc: "Track sent broadcasts with a comprehensive message dashboard and monitor performance.",
        },
        {
          title: "CRM integration",
          desc: "Connect campaigns to customer data for seamless, personalised broadcasts.",
        },
        {
          title: "Multi-channel support",
          desc: "Coordinate WhatsApp broadcasts with other channels for unified campaigns.",
        },
        {
          title: "Rich media support",
          desc: "Enhance broadcasts with images, videos, and documents for more engaging campaigns.",
        },
        {
          title: "Compliance and security-focused",
          desc: "Ensure adherence to WhatsApp's policies and data protection regulations.",
        },
      ],
      cta: "Get demo",
    },
    {
      title: "Gallabox",
      desc: "Gallabox is a versatile WhatsApp marketing platform that enables businesses to engage in bulk messaging campaigns. It offers a range of features designed to streamline communication and improve customer engagement through WhatsApp.",
      img: compareItemImg2,
      alt: "Gallabox WhatsApp broadcast dashboard",
      features: [
        {
          title: "Broadcast lists",
          desc: "Create and manage multiple broadcast lists for targeted messaging.",
        },
        {
          title: "Media support",
          desc: "Send images, videos, and documents in WhatsApp broadcast messages.",
        },
        {
          title: "Analytics dashboard",
          desc: "Track message delivery, opens, and engagement metrics.",
        },
        {
          title: "Team collaboration",
          desc: "Allow multiple team members to manage broadcasts and WhatsApp conversations together.",
        },
      ],
    },
    {
      title: "Wati.io",
      desc: "Wati.io provides a user-friendly interface for WhatsApp business automation, including bulk messaging capabilities. It's designed to help businesses scale their WhatsApp communication efficiently.",
      img: compareItemImg5,
      alt: "Wati WhatsApp business automation for large-scale broadcasts",
      features: [
        {
          title: "Chatbot integration",
          desc: "Combine bulk broadcasts with automated WhatsApp chatbot responses.",
        },
        {
          title: "Contact management",
          desc: "Organise and segment contacts for more effective targeted broadcasting.",
        },
        {
          title: "Template library",
          desc: "Access pre-designed WhatsApp message templates for quick campaign creation.",
        },
        {
          title: "Multi-agent inbox",
          desc: "Collaborate on customer follow-ups after broadcast campaigns.",
        },
      ],
    },
    {
      title: "Interkt",
      desc: "Interkt offers a comprehensive WhatsApp business solution that includes powerful bulk messaging features. It's tailored for businesses looking to leverage WhatsApp for marketing and customer support at scale.",
      img: compareItemImg4,
      alt: "Interkt WhatsApp marketing and customer support broadcast solution",
      features: [
        {
          title: "Audience segmentation",
          desc: "Create custom segments to deliver targeted broadcast messages.",
        },
        {
          title: "A/B testing",
          desc: "Test different message variations to optimise WhatsApp broadcast engagement.",
        },
        {
          title: "Automated workflows",
          desc: "Set up triggered WhatsApp broadcast sequences based on customer actions.",
        },
        {
          title: "Integration capabilities",
          desc: "Connect with third-party business tools for streamlined operations.",
        },
      ],
    },
    {
      title: "AiSensy",
      desc: "AiSensy is an AI-powered WhatsApp marketing platform that facilitates bulk messaging with intelligent features. It's designed to help businesses automate and optimize their WhatsApp communication strategies.",
      img: compareItemImg3,
      alt: "AiSensy AI-powered WhatsApp broadcast platform",
      features: [
        {
          title: "AI-powered personalization",
          desc: "Tailor broadcast content based on recipient data and behaviour for higher impact.",
        },
        {
          title: "Campaign builder",
          desc: "Intuitive drag-and-drop interface for building multi-step WhatsApp broadcast campaigns.",
        },
        {
          title: "Dynamic content",
          desc: "Insert dynamic personalised fields into broadcast messages for each recipient.",
        },
        {
          title: "Compliance tools",
          desc: "Ensure broadcasts meet WhatsApp's official guidelines and best practices.",
        },
      ],
    },
  ];
  const adaptList = [
    {
      pointer: "Boost Visibility",
      desc: "Connect with your audience where they are most active, ensuring higher open and response rates compared to traditional marketing channels.",
      img: salesImg1,
      alt: "Boost Visibility with WhatsApp broadcast",
    },
    {
      pointer: "Cost-effective marketing",
      desc: "Reduce marketing costs and maximise impact with WhatsApp’s reach and Pepper Cloud’s efficient broadcast system.",
      img: salesImg2,
      alt: "Cost-effective marketing through WhatsApp",
    },
    {
      pointer: "Personalised communication",
      desc: "Tailor messages to specific customer segments, enhancing relevance and making it more likely to drive conversions.",
      img: salesImg3,
      alt: "Personalised customer communication",
    },
    {
      pointer: "Instant Reach & Response",
      desc: "Send time-sensitive information quickly and receive instant feedback, enabling agile and results-driven marketing strategies.",
      img: salesImg4,
      alt: "Instant reach and response",
    },
    {
      pointer: "Optimised Experience",
      desc: "Provide value-added services like order updates, appointment reminders, and exclusive offers directly through a familiar platform.",
      img: salesImg5,
      alt: "Optimised customer experience",
    },
    {
      pointer: "Improved brand loyalty",
      desc: "Regular, personalised communications help build stronger relationships with customers, fostering brand loyalty and repeat business.",
      img: salesImg6,
      alt: "Improved brand loyalty",
    },
    {
      pointer: "Data-driven insights",
      desc: "Gain valuable insights into customer behaviour and campaign performance, enabling continuous optimisation of your marketing efforts.",
      img: salesImg7,
      alt: "Data-driven marketing insights",
    },
  ];
  return (
    <main>
      <SEO
        pathname={
          "https://peppercloud.com/whatsapp-crm-features/best-whatsapp-broadcast-messages-software/"
        }
        title={
          "Best WhatsApp Broadcast Software for Bulk Messages | Pepper Cloud"
        }
        keywords="whatsapp broadcast software,whatsapp broadcast,broadcast list whatsapp,whatsapp broadcast message,broadcast message whatsapp web,how to broadcast whatsapp,how does a broadcast work on whatsapp,how to do whatsapp broadcast,bulk messages through whatsapp,How to do WhatsApp broadcasts with WhatsApp Web integration?,how to broadcast whatsapp,what is broadcast in whatsapp"
        description={
          "Discover the ultimate way to automate and optimize customer interactions via bulk WhatsApp broadcast messages with Pepper Cloud's best WhatsApp broadcast software."
        }
        jsonLd={[
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "Pepper Cloud",
            legalName: "Pepper Cloud PTE LTD",
            url: "https://peppercloud.com/",
            logo: "https://peppercloud.com/icons/logo.png",
            foundingDate: "2017",
            address: [
              {
                "@type": "PostalAddress",
                streetAddress: "#04-01/02",
                addressLocality: "Blk 79 Ayer Rajah Crescent",
                addressRegion: "SG",
                postalCode: "139955",
                addressCountry: "Singapore",
              },
              {
                "@type": "PostalAddress",
                streetAddress:
                  "2nd Floor, Salarpuria Tower 1, 7th Block Koramangala",
                addressLocality: "Bengaluru",
                addressRegion: "KA",
                postalCode: "560095",
                addressCountry: "India",
              },
            ],
            contactPoint: {
              "@type": "ContactPoint",
              contactType: "customer support",
              telephone: "+6566562616",
              email: ["sales@peppercloud.com", "support@peppercloud.com"],
            },
            sameAs: [
              "https://twitter.com/peppercloudpte",
              "https://www.linkedin.com/company/peppercloud/",
              "https://www.facebook.com/PepperCloudPteLtd",
              "https://www.instagram.com/pepper.cloud/",
            ],
          },
          {
            "@context": "https://schema.org/",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "What is the role of CRM in retail?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Retail CRM plays a crucial role in managing customer interactions, tracking sales, and enhancing service across both online and offline channels.",
                },
              },
              {
                "@type": "Question",
                name: "Why is a specialized CRM necessary for e-commerce?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "A specialized e-commerce CRM addresses challenges such as cart abandonment, personalized recommendations, and multichannel support, ultimately enhancing customer experience and driving sales.",
                },
              },
              {
                "@type": "Question",
                name: "Is investing in a CRM worthwhile for small businesses?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Pepper Cloud CRM is beneficial for small e-commerce businesses as it improves customer service, streamlines operations, and enables data-driven decision-making, leading to growth and increased profitability.",
                },
              },
              {
                "@type": "Question",
                name: "Can Pepper Cloud assist with cart abandonment?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Pepper Cloud's e-commerce CRM automates cart abandonment recovery through targeted reminders and incentives, resulting in increased conversions.",
                },
              },
              {
                "@type": "Question",
                name: "How does Pepper Cloud facilitate multichannel sales?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Pepper Cloud's e-commerce CRM offers omnichannel capabilities, managing sales and customer interactions across websites, marketplaces, and social media platforms for a unified customer view.",
                },
              },
            ],
          },
        ]}
        ogData={{
          "og:image": [
            "/meta/og/1X1/home.png",
            "/meta/og/1024X512/home.png",
            "/meta/og/1200X630/home.png",
          ],
        }}
      />
      <section
        className={clsx(classes.SalesMangerSection, "sales-hero-section")}
      >
        <div className="container">
          <div className={classes.SalesMangerContainer}>
            <motion.div
              className={classes.heroContent}
              initial={{ opacity: 1, y: 30 }}
              transition={{ duration: 0.5 }}
              whileInView={{ opacity: 1, y: 0 }}
            >
              <h1 className="font-wix-semibold font-64 ">
                Revolutionise your customer outreach with WhatsApp broadcast
              </h1>
              <p className="font-wix-regular font-18">
                Harness the power of WhatsApp to boost your marketing campaigns
                and customer engagement. Pepper Cloud WhatsApp broadcast feature
                connects you with your audience instantly and effectively.
              </p>
              <div className="buttonContainer">
                <Link
                  className="primaryButton font-16 font-wix-medium font-white"
                  to="/contact/?utm_source=WhatsApp+CRM&utm_medium=Get+started"
                >
                  Book a free demo
                </Link>
              </div>
            </motion.div>
            <motion.div
              className={classes.bannerCards}
              initial={{ opacity: 1, y: 30 }}
              transition={{ duration: 0.5 }}
              whileInView={{ opacity: 1, y: 0 }}
            >
              <div
                className={clsx(
                  classes.cardContainer,
                  "bannerCard",
                  "blueCard"
                )}
              >
                <img src={bannerIcon4} />
                <h3 className="font-wix-semibold font-20 font-white">
                  Mass messaging:
                </h3>
                <p className="font-wix-regular font-18 color-black7">
                  Reach thousands of customers simultaneously with personalised
                  messages.
                </p>
              </div>
              <div
                className={clsx(
                  classes.cardContainer,
                  "bannerCard",
                  "greenCard"
                )}
              >
                <img src={bannerIcon3} />
                <h3 className="font-wix-semibold font-20 font-white">
                  Maximise reach:
                </h3>
                <p className="font-wix-regular font-18 color-black7">
                  Boost engagement rates with targeted, timely communications.
                </p>
              </div>
              <div
                className={clsx(
                  classes.cardContainer,
                  "bannerCard",
                  "regularCard"
                )}
              >
                <img src={bannerIcon1} />
                <h3 className="font-wix-semibold font-20 font-white">
                  Track performance:
                </h3>
                <p className="font-wix-regular font-18 color-black7">
                  Track campaign performance with real-time analytics for
                  data-driven decision making.
                </p>
              </div>
              <div
                className={clsx(
                  classes.cardContainer,
                  "bannerCard",
                  "purpleCard"
                )}
              >
                <img src={bannerIcon2} />
                <h3 className="font-wix-semibold font-20 font-white">
                  Easy web integration:
                </h3>
                <p className="font-wix-regular font-18 color-black7">
                  Seamlessly integrate WhatsApp broadcasting into your overall
                  marketing strategy.
                </p>
              </div>
            </motion.div>
          </div>
        </div>
      </section>
      <section className={classes.Client}>
        <div className="container">
          <p className="font-24 font-wix-semibold">
            Trusted by leading businesses for outstanding efficiency
          </p>
          <Swiper
            autoplay={{
              delay: 0,
              disableOnInteraction: false,
            }}
            breakpoints={{
              // For smaller screens (mobile)
              0: {
                slidesPerView: 2,
                freeMode: true,
                // grabCursor: false,
                spaceBetween: 40,
                slidesPerGroup: 1,
                // autoplay: false,
                // modules: [],
              },
              // For larger screens (desktop)
              768: {
                slidesPerView: 3,
                slidesPerGroup: 1,
                spaceBetween: 40,
              },
              1024: {
                slidesPerView: 4,
                slidesPerGroup: 1,
                spaceBetween: 40,
              },
              1200: {
                slidesPerView: 4,
                slidesPerGroup: 1,
                spaceBetween: 40,
              },
            }}
            className={classes.adaptSlider}
            grabCursor={true}
            loop={true}
            modules={[Autoplay]}
            speed={2500}
            slidesPerView={"auto"}
            // centeredSlides={true}
            spaceBetween={30}
          >
            {clientList.map((point) => (
              <SwiperSlide className="client-logo">
                <div>
                  <img
                    // alt={point.card.alt}
                    src={point.img}
                  />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </section>
      <section className={classes.benifitSection}>
        {benifitList.map((benifit) => (
          <section className={classes.integrationSection}>
            <div className="container">
              <div className={classes.integrationHeader}>
                <div className={classes.integrationLeft}>
                  <motion.h2
                    className="font-wix-semibold font-56 color-black1"
                    initial={{ opacity: 1, y: 20 }}
                    transition={{ duration: 0.3 }}
                    whileInView={{ opacity: 1, y: 0 }}
                  >
                    {benifit.title}
                  </motion.h2>
                  {benifit.points.map((pointer) => (
                    <motion.div
                      className={classes.benfitListItem}
                      initial={{ opacity: 0, y: 20 }}
                      transition={{ duration: 0.3 }}
                      whileInView={{ opacity: 1, y: 0 }}
                    >
                      <LazyImage
                        alt="How to create broadcast list."
                        className={classes.benfitIcon}
                        source={bannerTick}
                      />
                      <div className={classes.benfitListItemContent}>
                        <p className="font-wix-semibold font-20 color-black1">
                          {pointer.heading}
                        </p>
                        <p className="font-wix-regular font-18 color-black2">
                          {pointer.content}
                        </p>
                      </div>
                    </motion.div>
                  ))}
                </div>
                <div className={classes.integrationRight}>
                  <img
                    alt="Sending broadcast messages using WhatsApp."
                    className={classes.integrationRightImage}
                    src={benifit.img}
                  />
                </div>
              </div>
            </div>
          </section>
        ))}
        <div className={classes.absoulteCard}>
          <div className="container">
            <div className={classes.integrationHeader}>
              <div className={classes.integrationLeft}>
                <motion.h2
                  className="font-wix-semibold font-48 font-white"
                  initial={{ opacity: 1, y: 20 }}
                  transition={{ duration: 0.3 }}
                  whileInView={{ opacity: 1, y: 0 }}
                >
                  What is a broadcast on WhatsApp?
                </motion.h2>
                <motion.p
                  className="font-wix-regular font-18 font-white"
                  initial={{ opacity: 1, y: 20 }}
                  transition={{ duration: 0.3 }}
                  whileInView={{ opacity: 1, y: 0 }}
                >
                  A WhatsApp broadcast is a feature that allows you to send a
                  single message to multiple recipients simultaneously. Unlike
                  group messages, broadcasts maintain the privacy of recipients
                  as they can't see each other. With Pepper Cloud bulk WhatsApp
                  broadcast feature, businesses can scale this functionality to
                  reach thousands of customers efficiently, all while
                  maintaining a personal touch.
                </motion.p>
              </div>
              <div className={classes.integrationRight}>
                <img
                  alt="Recipients receiving broadcast message privately."
                  className={classes.integrationRightImage}
                  src={cardImg2}
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className={classes.experienceContainer} ref={ref}>
        <section className={classes.accordianTabs}>
          <div className="container">
            <div className="headercenterContainer">
              <motion.h2
                className="font-wix-semibold font-56 text-black1"
                initial={{ opacity: 1, y: 20 }}
                transition={{ duration: 0.3 }}
                whileInView={{ opacity: 1, y: 0 }}
              >
                Why Pepper Cloud CRM is the best WhatsApp broadcast software?
              </motion.h2>
            </div>
            <div className={classes.experienceInnerContainer}>
              <div className={classes.experienceContainerLeft}>
                {experienceList.map((faq, index) => (
                  <motion.div
                    key={index}
                    className={clsx(
                      classes.faqBoxAccordian,
                      activeAccordian === index && "active",
                      "text-color2"
                    )}
                    onClick={() => {
                      if (activeAccordian !== index) {
                        setActiveAccordian(index); // only switch if different
                      }
                    }}
                  >
                    <div
                      className={clsx(
                        classes.experienceHeader,
                        activeAccordian === index && "noClick"
                      )}
                    >
                      <h3 className="font-20 font-wix-semibold">{faq.title}</h3>
                      <img
                        alt="Arrow"
                        className={clsx(
                          classes.downArrow,
                          activeAccordian === index && "active"
                        )}
                        src={downArrow}
                      />
                    </div>

                    <Collapse
                      className={classes.body}
                      in={activeAccordian === index}
                    >
                      <p className="font-18 font-wix-regular color-black2 exp-desc">
                        {faq.desc}
                      </p>
                      {/* <a
                        className="font-18 font-wix-regular view-more-link"
                        href={faq.linkUrl}
                      >
                        {faq.lintText}{" "}
                        <img alt="Arrow Right" src={arrowRight} />{" "}
                      </a> */}
                      <motion.img
                        alt={faq.alt}
                        initial={{ opacity: 1, y: 20 }}
                        src={faq.img}
                        transition={{ duration: 0.3 }}
                        whileInView={{ opacity: 1, y: 0 }}
                      />
                    </Collapse>
                  </motion.div>
                ))}
              </div>
              <div className={classes.experienceContainerRight}>
                {experienceList.map(
                  (experience, index) =>
                    index === activeAccordian && (
                      <motion.img
                        initial={{ opacity: 1, y: 20 }}
                        src={experience.img}
                        alt={experience.alt}
                        transition={{ duration: 0.3 }}
                        whileInView={{ opacity: 1, y: 0 }}
                      />
                    )
                )}
              </div>
            </div>
          </div>
        </section>
      </section>
      <section className={classes.salesCrmCarousel}>
        <div className="container">
          <div className="header-section">
            <motion.h2
              className="font-wix-semibold font-56 color-black1"
              initial={{ opacity: 1, y: 20 }}
              transition={{ duration: 0.3 }}
              whileInView={{ opacity: 1, y: 0 }}
            >
              Benefits of bulk WhatsApp broadcast for your business
            </motion.h2>
          </div>
        </div>
        <Swiper
          autoplay={{
            delay: 0,
            disableOnInteraction: false,
          }}
          breakpoints={{
            // For smaller screens (mobile)
            0: {
              slidesPerView: 1,
              freeMode: true,
              // grabCursor: false,
              spaceBetween: 15,
              slidesPerGroup: 1,
              // autoplay: false,
              // modules: [],
            },
            // For larger screens (desktop)
            768: {
              slidesPerView: 2,
              slidesPerGroup: 1,
              spaceBetween: 15,
            },
            1024: {
              slidesPerView: 4,
              slidesPerGroup: 1,
              spaceBetween: 15,
            },
          }}
          className={classes.adaptSlider}
          grabCursor={true}
          loop={true}
          modules={[Autoplay]}
          speed={5000}
          slidesPerView={"auto"}
          // centeredSlides={true}
          spaceBetween={30}
        >
          {adaptList.map((point, index) => (
            <SwiperSlide className={classes.adaptsBox}>
              <div className={classes.adaptBoxHeader}>
                <img
                  // alt={point.card.alt}
                  className={classes.adaptBoxImg}
                  src={point.img}
                />
                <p className="font-24 font-wix-semibold lineHeight-1">
                  {point.pointer}
                </p>
              </div>
              <div className={classes.adaptDescription}>
                <p className="font-wix-regular font-18  ">{point.desc}</p>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
        <div className={classes.absoulteCard}>
          <TruestedSection shadow background={true} />
        </div>
      </section>
      <section>
        <section className={classes.realWorldTabs}>
          <div className="container">
            <div className="centerContainer">
              <motion.h2
                className="font-wix-semibold font-56 color-black1"
                initial={{ opacity: 1, y: 20 }}
                transition={{ duration: 0.3 }}
                whileInView={{ opacity: 1, y: 0 }}
              >
                Applications and use cases of bulk WhatsApp broadcast
              </motion.h2>
              <div
                className={classes.tabsContainer}
                ref={sectionRef}
                style={{
                  display: "flex",
                  overflowX: "auto",
                  scrollBehavior: "smooth",
                  scrollbarWidth: "none",
                  msOverflowStyle: "none",
                }}
              >
                <div
                  className={clsx(
                    classes.tab,
                    "font-wix-semibold",
                    "font-20",
                    activeRealWorld === 0 && "active"
                  )}
                  onClick={() => setActiveRealWorld(0)}
                >
                  E-commerce and retail
                </div>
                <div
                  className={clsx(
                    classes.tab,
                    "font-wix-semibold",
                    "font-20",
                    activeRealWorld === 1 && "active"
                  )}
                  onClick={() => setActiveRealWorld(1)}
                >
                  Healthcare
                </div>
                <div
                  className={clsx(
                    classes.tab,
                    "font-wix-semibold",
                    "font-20",
                    activeRealWorld === 2 && "active"
                  )}
                  onClick={() => setActiveRealWorld(2)}
                >
                  Travel and hospitality
                </div>
                <div
                  className={clsx(
                    classes.tab,
                    "font-wix-semibold",
                    "font-20",
                    activeRealWorld === 3 && "active"
                  )}
                  onClick={() => setActiveRealWorld(3)}
                >
                  Financial services
                </div>
                <div
                  className={clsx(
                    classes.tab,
                    "font-wix-semibold",
                    "font-20",
                    activeRealWorld === 4 && "active"
                  )}
                  onClick={() => setActiveRealWorld(4)}
                >
                  Education
                </div>
              </div>
            </div>

            <div className={classes.tabCard}>
              <div className={classes.tabCardLeftContainer}>
                {tabContentData.map(
                  (listItem, index) =>
                    index === activeRealWorld && (
                      <div>
                        <motion.p
                          className="font-wix-regular font-18 color-black2"
                          initial={{ opacity: 0, y: 20 }}
                          transition={{ duration: 0.3 }}
                          whileInView={{ opacity: 1, y: 0 }}
                        >
                          {listItem.subtitle}
                        </motion.p>
                        <div className={classes.benfitListContainer}>
                          {listItem.tabContent.map((item) => (
                            <motion.div
                              className={classes.benfitListItem}
                              initial={{ opacity: 0, y: 20 }}
                              transition={{ duration: 0.3 }}
                              whileInView={{ opacity: 1, y: 0 }}
                            >
                              <LazyImage
                                alt={item.alt}
                                className={classes.benfitIcon}
                                source={bannerTick}
                              />
                              <div className={classes.benfitListItemContent}>
                                <p className="font-wix-semibold font-20 color-black1">
                                  {item.heading}
                                </p>
                                <p className="font-wix-regular font-18 color-black2">
                                  {item.content}
                                </p>
                              </div>
                            </motion.div>
                          ))}
                        </div>
                      </div>
                    )
                )}
              </div>
              <div className={classes.tabCardRightContainer}>
                {tabContentData.map(
                  (listItem, index) =>
                    index === activeRealWorld && (
                      <motion.div
                        initial={{ opacity: 1, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.3 }}
                        // className={classes.aiSectionRight}
                      >
                        <LazyImage
                          alt={listItem.alt}
                          source={listItem.image}
                          width={"100%"}
                        />
                      </motion.div>
                    )
                )}
              </div>
            </div>
          </div>
        </section>
      </section>
      <section>
        <div className="container">
          <div className="header">
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-medium font-56 font-black1"
            >
              5 Best bulk WhatsApp broadcast software
            </motion.h2>
          </div>
          <div className={classes.compareSectionContainer}>
            <div className={classes.compareSectionContainerLeftSection}>
              {compareItems.map((item, index) => (
                <div
                  className={clsx(
                    classes.compareSectionLeftItem,
                    activeCompare === `#section${index}` && "active"
                  )}
                  onClick={() => {
                    scrollToSection(`#section${index}`);
                    setActiveCompare(`#section${index}`);
                  }}
                >
                  <a
                    href={`#section${index}`}
                    className={clsx(
                      "font-22 font-wix-medium font-black1",
                      activeCompare === `#section${index}` && "font-wix-bold"
                    )}
                  >
                    {item}
                  </a>
                </div>
              ))}
            </div>
            <div className={classes.compareSectionContainerRightSection}>
              {compareData.map((data, outerIndex) => (
                <div
                  className={classes.compareItemContainer}
                  id={`#section${outerIndex}`}
                >
                  <h3
                    className="font-40 font-wix-semibold font-black1"
                    initial={{ opacity: 1, y: 20 }}
                    transition={{ duration: 0.3 }}
                    whileInView={{ opacity: 1, y: 0 }}
                  >
                    {data.title}
                  </h3>
                  <p
                    className="font-wix-regular font-18 font-black1"
                    initial={{ opacity: 1, y: 20 }}
                    transition={{ duration: 0.3 }}
                    whileInView={{ opacity: 1, y: 0 }}
                  >
                    {data.desc}
                  </p>
                  <img alt={data.alt} className="productImage" src={data.img} />
                  <div className={classes.faqsContainer}>
                    {data.features.map((faq, innerIndex) => (
                      <motion.div
                        className={classes.faqBox}
                        onClick={() =>
                          setActiveAccordian(
                            `${outerIndex}-${innerIndex}` === activeAccordian
                              ? -1
                              : `${outerIndex}-${innerIndex}`
                          )
                        }
                        transition={{ duration: 1, delay: innerIndex * 0.01 }}
                        whileInView={{ opacity: [0, 1], y: [50, 0] }}
                      >
                        <div className={classes.topFiveHeader}>
                          <h3 className="font-20 font-wix-semibold">
                            {faq.title}
                          </h3>
                          <img
                            alt="Arrow"
                            className={clsx(
                              classes.downArrow,
                              `${outerIndex}-${innerIndex}` ===
                                activeAccordian && "active"
                            )}
                            src={downArrow}
                          />
                        </div>
                        <Collapse
                          className={classes.body}
                          in={activeAccordian === `${outerIndex}-${innerIndex}`}
                        >
                          <p className="font-18 font-wix-regular color-black2">
                            {faq.desc}
                          </p>
                        </Collapse>
                      </motion.div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
      <div className={classes.testimonials}>
        <TestimonialSlider
          desc={
            "Discover how businesses are transforming customer engagement with Pepper Cloud."
          }
          heading={"Real stories. Real results."}
          noButton={true}
        />
      </div>
      <div className={classes.wpFaq}>
        <FaqSection
          backgroundColor={"#FFFFFF"}
          faqs={faqs}
          heading={"FAQs - Bulk WhatsApp broadcast"}
        />
      </div>
      <section className={classes.commonPageFooterSection}>
        <div className="container">
          <div className="centerContainer">
            <motion.h2
              className="font-wix-medium font-56 font-white"
              initial={{ opacity: 1, y: 30 }}
              transition={{ duration: 0.5 }}
              whileInView={{ opacity: 1, y: 0 }}
            >
              Scale your messaging: Drive results with bulk WhatsApp broadcasts!
            </motion.h2>
            <Link
              className="primaryButton font-20 font-wix-medium font-white"
              to="/contact/?utm_source=WhatsApp+CRM&utm_medium=Get+started"
            >
              Get started
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
};

export default WhatsappBroadcast;
